import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import config from "../config";

function moderate(text) {
  // Simple moderation: mask common offensive terms
  const blocklist = ["perra", "mierda", "puta", "pendejo", "idiota"];
  let safe = text;
  blocklist.forEach((w) => {
    const re = new RegExp(`\\b${w}\\b`, "gi");
    safe = safe.replace(re, "[contenido moderado]");
  });
  return safe;
}

export default function Chat() {
  const [contactos, setContactos] = useState([]);
  const [selectedContacto, setSelectedContacto] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingContactos, setLoadingContactos] = useState(true);
  const [error, setError] = useState("");

  // Fetch contactos on mount
  useEffect(() => {
    const fetchContactos = async () => {
      try {
        setLoadingContactos(true);
        const url = `${config.n8nWebhookBase}${config.n8nContactosPath}`;
        const res = await fetch(url, {
          method: "GET",
          headers: { "Accept": "application/json" },
        });
        let json;
        const text = await res.text();
        try { json = JSON.parse(text); } catch { json = { error: text || `HTTP ${res.status}` }; }
        if (res.ok) {
          const arr = Array.isArray(json?.data) ? json.data : [];
          setContactos(arr);
          if (arr.length > 0) setSelectedContacto(arr[0].contacto);
        } else {
          setError(`Error al cargar contactos: ${json?.error || res.status}`);
        }
      } catch (err) {
        setError(`Error: ${err.message}`);
      } finally {
        setLoadingContactos(false);
      }
    };
    fetchContactos();
  }, []);

  const sendRequest = async (e) => {
    e.preventDefault();
    setError("");
    setMessages([]);
    if (!selectedContacto) {
      setError("Por favor selecciona un contacto.");
      return;
    }
    try {
      setLoading(true);
      const url = `${config.n8nWebhookBase}${config.n8nAlertasPath}?contacto=${encodeURIComponent(selectedContacto)}`;
      const res = await fetch(url, {
        method: "GET",
        headers: { "Accept": "application/json" },
      });
      let json;
      const text = await res.text();
      try { json = JSON.parse(text); } catch { json = { error: text || `HTTP ${res.status}` }; }
      if (!res.ok) {
        const msg = json?.error || json?.message || `Webhook respondió ${res.status}`;
        throw new Error(String(msg));
      }
      const arr = Array.isArray(json?.data) ? json.data : [];
      const cleaned = arr.map((item) => ({ ...item, date: moderate(String(item.date ?? "")) }));
      setMessages(cleaned);
    } catch (err) {
      setError(err.message || "Error al consultar el webhook.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="kb-container">
      <section className="kb-card">
        <h2 className="kb-title">Chat de Alertas</h2>
        <p className="kb-subtitle">Selecciona un contacto y consulta sus mensajes.</p>
        {loadingContactos ? (
          <div className="kb-empty">Cargando contactos...</div>
        ) : (
          <form className="kb-form" onSubmit={sendRequest}>
            <label className="kb-label" htmlFor="contacto-select">Selecciona contacto</label>
            <select
              id="contacto-select"
              className="kb-input"
              value={selectedContacto}
              onChange={(e) => setSelectedContacto(e.target.value)}
              disabled={contactos.length === 0}
            >
              <option value="">-- Selecciona un contacto --</option>
              {contactos.map((c) => (
                <option key={c.contacto} value={c.contacto}>
                  {c.contacto}
                </option>
              ))}
            </select>
            <button className="kb-btn" type="submit" disabled={loading || !selectedContacto}>
              {loading ? "Consultando..." : "Consultar Mensajes"}
            </button>
            {error && <div className="kb-error">{error}</div>}
          </form>
        )}
      </section>

      <section className="kb-card">
        <h3 className="kb-title">Mensajes recibidos</h3>
        {messages.length === 0 && !loading && (
          <div className="kb-empty">Sin mensajes todavía.</div>
        )}
        <div className="kb-chat-list">
          {messages.map((m, idx) => (
            <article key={idx} className="kb-chat-item">
              <ReactMarkdown>{m.date}</ReactMarkdown>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
